/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon64Regular = forwardRef('ArrowFigureACircleRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M17.5 32a1.5 1.5 0 0 1 1.5-1.5h23.104l-7.94-7.94a1.5 1.5 0 0 1 2.122-2.12l8.378 8.378a4.5 4.5 0 0 1 0 6.364l-8.378 8.379a1.5 1.5 0 0 1-2.122-2.122l7.94-7.939H19a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 32C6 17.64 17.64 6 32 6s26 11.64 26 26-11.64 26-26 26S6 46.36 6 32ZM32 9C19.297 9 9 19.297 9 32s10.297 23 23 23 23-10.297 23-23S44.703 9 32 9Z" })));
});
